import { PageType } from "../interface";

export const metaData: Record<PageType, { title: string; description: string; keywords: string }> = {
    galleria: {
      title: 'Galleria - Opere di Emanuela Degan',
      description: 'Sfoglia la galleria delle opere di Emanuela Degan, pittore e pittrice a Firenze e Mugello.',
      keywords: 'Emanuela, Degan, Emanuela Degan, galleria, opere, arte firenze, arte mugello, Pittore firenze, Pittrice Firenze, pittore, pittrice mugello, Pittore mugello, pittrice mugello'
    },
    biografia: {
      title: 'Biografia - Emanuela Degan',
      description: 'Leggi la biografia di Emanuela Degan, artista e pittrice di Firenze e Mugello.',
      keywords: 'Emanuela, Degan, biografia, Emanuela Degan, manu degan art, arte firenze, arte mugello, vita Emanuela Degan, premi emanuela degan, mostre arte firenze, mostre emanuela degan'
    },
    "in-primo-piano": {
      title: 'In Primo Piano - Emanuela Degan',
      description: 'Sfoglia la galleria delle opere di Emanuela Degan, pittore e pittrice a Firenze e Mugello.',
      keywords: 'galleria, opere, Emanuela Degan, manu degan art, arte, pittore, pittrice'
    },
    scuola: {
      title: 'Scuola - Corsi d\'Arte con Emanuela Degan',
      description: 'Scopri i corsi d\'arte tenuti da Emanuela Degan a Firenze e Mugello.',
      keywords: 'scuola, corsi d\'arte Emanuela Degan, Emanuela Degan, arte, Firenze, Mugello'
    },
    contatti: {
      title: 'Contatti - Mettiti in contatto con Emanuela Degan',
      description: 'Contatta Emanuela Degan per informazioni su opere d\'arte, corsi e collaborazioni.',
      keywords: 'contatti, Emanuela, Degan, Emanuela Degan, manu degan, arte, Firenze, Mugello'
    }
  };